var $9094fee841373e1f$exports = {};
$9094fee841373e1f$exports = {
    "more": `Flere elementer`
};


export {$9094fee841373e1f$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
